import { TRACING_QUERY } from 'graphql/queries';
import { useQuery } from 'hooks';
import React, { createContext, useEffect, useMemo, useState, } from 'react';
const TracingContext = createContext(null);
export const TracingProvider = ({ contentBlockData, locale, children, }) => {
    if (!contentBlockData)
        return React.createElement("span", null, children);
    const [hasRefetched, setHasRefetched] = useState(false);
    const { loading, error, result: { communitySummary, latestTransactions } = {}, refetch, } = useQuery(TRACING_QUERY, { lang: locale });
    const [activeCommunity, setActiveCommunity] = useState(null);
    useEffect(() => {
        // Refetch if there's an error, because the tracing is temporary unavailable
        if (error === 'PRODUCT_TRACING_DATA_UNAVAILABLE' && !hasRefetched) {
            setHasRefetched(true);
            setTimeout(refetch, 1000);
        }
    }, [error]);
    const communities = useMemo(() => {
        if (!communitySummary)
            return [];
        // @ts-ignore
        return communitySummary.communities.edges.map(({ node }) => node);
    }, [communitySummary]);
    return (React.createElement(TracingContext.Provider, { value: {
            contentBlockData,
            query: { communitySummary, latestTransactions },
            loading,
            error,
            activeCommunity,
            setActiveCommunity,
            communities,
        } }, children));
};
export default TracingContext;
